import { ScreenShareIcon } from "@livekit/components-react";
import * as React from "react";

/** Full-stage static UI for the local sharer — no live video, prevents capture feedback loops. */
export function LiveInterviewPresentingStage({ title, subtitle }) {
  return (
    <div className="li-presenting-stage" role="status" aria-live="polite">
      <ScreenShareIcon className="li-presenting-stage-icon" aria-hidden />
      <p className="li-presenting-stage-title">{title}</p>
      {subtitle ? <p className="li-presenting-stage-sub">{subtitle}</p> : null}
    </div>
  );
}
